import { FC } from "react";

export const LoadingSpinner: FC = () => (
  <div className="h-100 w-100 d-flex align-items-center justify-content-center">
    <div className="d-inline-block shadow">
      <div className="d-flex align-items-center gap-3 p-4">
        <div className="spinner-border text-primary" aria-hidden="true"></div>
        <p role="status" className="text-light">
          Caricamento...
        </p>
      </div>
    </div>
  </div>
);
